

















import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectForm from '@/views/project/project-form.component.vue';
import ProjectService from '@/domain/project/project.service';
import ProjectPersist from '../../domain/project/project-persist.entity';
import ProjectPersistTransfer from '../../domain/project/project-persist-transfer.entity';

@Component({
  components: {
    ProjectForm,
  },
})
export default class ProjectModal extends Vue {
  @Prop({
    required: true,
    default: false,
  })
  private dialog!: boolean;

  @Prop({
    required: true,
    default: new ProjectPersist(),
  })
  private project!: ProjectPersist;

  @Prop({
    required: true,
    default: false,
  })
  private editingProject!: boolean;

  public $refs!: any;

  private saveProject(project: ProjectPersist): void {
    const projectToPersist = ProjectPersistTransfer.of(project);
    ProjectService.saveProject(projectToPersist)
      .then((response: any) => {
        if (response && response.status === 200) {
          this.close();
          this.refresh(project);
        }
      })
      .catch((err: any) => console.log(err));
  }

  private close(): void {
    this.$emit('close');
  }

  private refresh(project: ProjectPersist): void {
    this.$emit('refresh', project);
  }
}
